let timeoutRef: any

// eslint-disable-next-line
export default function debounce(fn: any, delay = 800): void {
    clearTimeout(timeoutRef)
    timeoutRef = setTimeout(fn, delay)
}
